import { useMutation } from "react-query";
import { getAiSearchResponse } from "../../services/aiSearch";

/**
 * LLM/AI search mutation (POST article/ai-search).
 */
export function useAiSearchMutation() {
  return useMutation(({ query, product, session_id, conversation_history }) =>
    getAiSearchResponse({ query, product, session_id, conversation_history })
  );
}
